
import { FormLabel } from "@/components/ui/form";

interface FormHeadingProps {
  label: string;
  description?: string;
}

export const FormHeading: React.FC<FormHeadingProps> = ({ label, description }) => {
  return (
    <div className="space-y-1">
      <FormLabel>{label}</FormLabel>
      {description && (
        <p className="text-sm text-muted-foreground">{description}</p>
      )}
    </div>
  );
};
